/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { StreemApiAcceptRoomInvitationRequestToJSON, StreemApiAcceptRoomInvitationResponseFromJSON, StreemApiArchiveAndDeleteRoomResponseFromJSON, StreemApiCancelRoomInvitationRequestToJSON, StreemApiCancelRoomInvitationResponseFromJSON, StreemApiCreateReadonlyRoomTokenResponseFromJSON, StreemApiCreateRecordingResponseFromJSON, StreemApiCreateRoomInvitationRequestToJSON, StreemApiCreateRoomInvitationResponseFromJSON, StreemApiCreateRoomOutcomeReportRequestToJSON, StreemApiCreateRoomOutcomeReportResponseFromJSON, StreemApiCreateRoomRequestToJSON, StreemApiCreateRoomResponseFromJSON, StreemApiCreateRoomShareTokenRequestToJSON, StreemApiCreateRoomShareTokenResponseFromJSON, StreemApiCreateRoomTokenResponseFromJSON, StreemApiCreateRoomVideoCredentialsRequestToJSON, StreemApiCreateRoomVideoCredentialsResponseFromJSON, StreemApiCreateRoomWallCredentialsResponseFromJSON, StreemApiCreateStreemshotRequestToJSON, StreemApiCreateStreemshotResponseFromJSON, StreemApiCreateStreemshotRevisionRequestToJSON, StreemApiCreateStreemshotRevisionResponseFromJSON, StreemApiFinalizeRoomNoteResponseFromJSON, StreemApiFulfillMeshResponseFromJSON, StreemApiFulfillRecordingRequestToJSON, StreemApiFulfillRecordingResponseFromJSON, StreemApiFulfillStreemshotRequestToJSON, StreemApiFulfillStreemshotResponseFromJSON, StreemApiGetBookmarkResponseFromJSON, StreemApiGetGpsPositionResponseFromJSON, StreemApiGetLayoutEstimationResponseFromJSON, StreemApiGetMeshResponseFromJSON, StreemApiGetRoomCallLogEntryResponseFromJSON, StreemApiGetRoomInvitationResponseFromJSON, StreemApiGetRoomNoteResponseFromJSON, StreemApiGetRoomOutcomeReportResponseFromJSON, StreemApiGetRoomResponseFromJSON, StreemApiGetRoomShareTokenResponseFromJSON, StreemApiGetRoomWallItemsResponseFromJSON, StreemApiGetSceneshotResponseFromJSON, StreemApiGetStreemshotNoteResponseFromJSON, StreemApiGetStreemshotResponseFromJSON, StreemApiGetTexturedMeshResponseFromJSON, StreemApiLeaveRoomResponseFromJSON, StreemApiListGpsPositionsResponseFromJSON, StreemApiListMeshesResponseFromJSON, StreemApiListRecordingsResponseFromJSON, StreemApiListRoomArtifactsResponseFromJSON, StreemApiListRoomOutcomeReportsResponseFromJSON, StreemApiListRoomParticipantsResponseFromJSON, StreemApiListRoomShareTokensResponseFromJSON, StreemApiListRoomTranscriptionResponseFromJSON, StreemApiListRoomsResponseFromJSON, StreemApiListSceneshotsResponseFromJSON, StreemApiListStreemshotsResponseFromJSON, StreemApiRejectRoomInvitationRequestToJSON, StreemApiRejectRoomInvitationResponseFromJSON, StreemApiUpdateRoomNoteRequestToJSON, StreemApiUpdateRoomNoteResponseFromJSON, StreemApiUpdateRoomRequestToJSON, StreemApiUpdateRoomResponseFromJSON, StreemApiUpdateStreemshotNoteRequestToJSON, StreemApiUpdateStreemshotNoteResponseFromJSON, } from '../models';
/**
 *
 */
export class RoomsApi extends runtime.BaseAPI {
    /**
     * Mark invitation as answered by invitee
     * Accept Invitation
     */
    async acceptRoomInvitationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling acceptRoomInvitation.');
        }
        if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
            throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling acceptRoomInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/accept`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiAcceptRoomInvitationRequestToJSON(requestParameters.streemApiAcceptRoomInvitationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiAcceptRoomInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Mark invitation as answered by invitee
     * Accept Invitation
     */
    async acceptRoomInvitation(roomSid, invitationSid, streemApiAcceptRoomInvitationRequest) {
        const response = await this.acceptRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiAcceptRoomInvitationRequest: streemApiAcceptRoomInvitationRequest });
        return await response.value();
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete
     */
    async archiveAndDeleteRoomRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling archiveAndDeleteRoom.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/archive-and-delete`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete
     */
    async archiveAndDeleteRoom(roomSid) {
        await this.archiveAndDeleteRoomRaw({ roomSid: roomSid });
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete along with the caller (non-expert)
     */
    async archiveAndDeleteRoomAndDeleteNonExpertParticipantRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling archiveAndDeleteRoomAndDeleteNonExpertParticipant.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/~archive-and-delete`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiArchiveAndDeleteRoomResponseFromJSON(jsonValue));
    }
    /**
     * Archives all room\'s Assets to S3 bucket and deletes them from storage, and hides from Call Logs
     * Archive Room assets and Delete along with the caller (non-expert)
     */
    async archiveAndDeleteRoomAndDeleteNonExpertParticipant(roomSid) {
        const response = await this.archiveAndDeleteRoomAndDeleteNonExpertParticipantRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Mark invitation as cancelled (by inviter)
     * Cancel Invitation
     */
    async cancelRoomInvitationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling cancelRoomInvitation.');
        }
        if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
            throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling cancelRoomInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/cancel`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCancelRoomInvitationRequestToJSON(requestParameters.streemApiCancelRoomInvitationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCancelRoomInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Mark invitation as cancelled (by inviter)
     * Cancel Invitation
     */
    async cancelRoomInvitation(roomSid, invitationSid, streemApiCancelRoomInvitationRequest) {
        const response = await this.cancelRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiCancelRoomInvitationRequest: streemApiCancelRoomInvitationRequest });
        return await response.value();
    }
    /**
     * Create a new token to use to connect to a Room with readonly privileges
     * Create Readonly Token
     */
    async createReadonlyRoomTokenRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createReadonlyRoomToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/readonly-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateReadonlyRoomTokenResponseFromJSON(jsonValue));
    }
    /**
     * Create a new token to use to connect to a Room with readonly privileges
     * Create Readonly Token
     */
    async createReadonlyRoomToken(roomSid) {
        const response = await this.createReadonlyRoomTokenRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Create a new Streem Room
     * Create Room
     */
    async createRoomRaw(requestParameters) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateRoomRequestToJSON(requestParameters.streemApiCreateRoomRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomResponseFromJSON(jsonValue));
    }
    /**
     * Create a new Streem Room
     * Create Room
     */
    async createRoom(streemApiCreateRoomRequest) {
        const response = await this.createRoomRaw({ streemApiCreateRoomRequest: streemApiCreateRoomRequest });
        return await response.value();
    }
    /**
     * Create a new Room Invitation, which allows the invited User to have access to the Room
     * Create Room Invitation
     */
    async createRoomInvitationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/invitations`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateRoomInvitationRequestToJSON(requestParameters.streemApiCreateRoomInvitationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Create a new Room Invitation, which allows the invited User to have access to the Room
     * Create Room Invitation
     */
    async createRoomInvitation(roomSid, streemApiCreateRoomInvitationRequest) {
        const response = await this.createRoomInvitationRaw({ roomSid: roomSid, streemApiCreateRoomInvitationRequest: streemApiCreateRoomInvitationRequest });
        return await response.value();
    }
    /**
     * Create Room Outcome Report artifact for this Room
     * Create Room Outcome Report
     */
    async createRoomOutcomeReportRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomOutcomeReport.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateRoomOutcomeReportRequestToJSON(requestParameters.streemApiCreateRoomOutcomeReportRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomOutcomeReportResponseFromJSON(jsonValue));
    }
    /**
     * Create Room Outcome Report artifact for this Room
     * Create Room Outcome Report
     */
    async createRoomOutcomeReport(roomSid, streemApiCreateRoomOutcomeReportRequest) {
        const response = await this.createRoomOutcomeReportRaw({ roomSid: roomSid, streemApiCreateRoomOutcomeReportRequest: streemApiCreateRoomOutcomeReportRequest });
        return await response.value();
    }
    /**
     * Create a new ON_DEVICE Recording for a room
     * Create Recording
     */
    async createRoomRecordingRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomRecording.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/recordings`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRecordingResponseFromJSON(jsonValue));
    }
    /**
     * Create a new ON_DEVICE Recording for a room
     * Create Recording
     */
    async createRoomRecording(roomSid) {
        const response = await this.createRoomRecordingRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Create a new Share Token, which can be provided as `Authorization: ShareToken [token]` to gain readonly access to the Room
     * Create Share Token
     */
    async createRoomShareTokenRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomShareToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/share-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateRoomShareTokenRequestToJSON(requestParameters.streemApiCreateRoomShareTokenRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomShareTokenResponseFromJSON(jsonValue));
    }
    /**
     * Create a new Share Token, which can be provided as `Authorization: ShareToken [token]` to gain readonly access to the Room
     * Create Share Token
     */
    async createRoomShareToken(roomSid, streemApiCreateRoomShareTokenRequest) {
        const response = await this.createRoomShareTokenRaw({ roomSid: roomSid, streemApiCreateRoomShareTokenRequest: streemApiCreateRoomShareTokenRequest });
        return await response.value();
    }
    /**
     * Create a new wall/video token to use to connect to a Room as a User
     * Create wall/video Token
     */
    async createRoomTokenRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomToken.');
        }
        if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
            throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomToken.');
        }
        const queryParameters = {};
        if (requestParameters.preflight !== undefined) {
            queryParameters['preflight'] = requestParameters.preflight;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/participants/{user_sid}/tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomTokenResponseFromJSON(jsonValue));
    }
    /**
     * Create a new wall/video token to use to connect to a Room as a User
     * Create wall/video Token
     */
    async createRoomToken(roomSid, userSid, preflight) {
        const response = await this.createRoomTokenRaw({ roomSid: roomSid, userSid: userSid, preflight: preflight });
        return await response.value();
    }
    /**
     * Create new credentials to use to connect to a Room as a User
     * Create Video credentials
     */
    async createRoomVideoCredentialsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomVideoCredentials.');
        }
        if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
            throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomVideoCredentials.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/participants/{user_sid}/credentials/video`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateRoomVideoCredentialsRequestToJSON(requestParameters.streemApiCreateRoomVideoCredentialsRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomVideoCredentialsResponseFromJSON(jsonValue));
    }
    /**
     * Create new credentials to use to connect to a Room as a User
     * Create Video credentials
     */
    async createRoomVideoCredentials(roomSid, userSid, streemApiCreateRoomVideoCredentialsRequest) {
        const response = await this.createRoomVideoCredentialsRaw({ roomSid: roomSid, userSid: userSid, streemApiCreateRoomVideoCredentialsRequest: streemApiCreateRoomVideoCredentialsRequest });
        return await response.value();
    }
    /**
     * Create new wall credentials to use to connect/update the room wall
     * Create wall credentials
     */
    async createRoomWallCredentialsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createRoomWallCredentials.');
        }
        if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
            throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling createRoomWallCredentials.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/participants/{user_sid}/credentials/wall`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateRoomWallCredentialsResponseFromJSON(jsonValue));
    }
    /**
     * Create new wall credentials to use to connect/update the room wall
     * Create wall credentials
     */
    async createRoomWallCredentials(roomSid, userSid) {
        const response = await this.createRoomWallCredentialsRaw({ roomSid: roomSid, userSid: userSid });
        return await response.value();
    }
    /**
     * Create a new streemshot request
     * Create Streemshot Request
     */
    async createStreemshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createStreemshot.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling createStreemshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/request`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateStreemshotRequestToJSON(requestParameters.streemApiCreateStreemshotRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateStreemshotResponseFromJSON(jsonValue));
    }
    /**
     * Create a new streemshot request
     * Create Streemshot Request
     */
    async createStreemshot(roomSid, streemshotSid, streemApiCreateStreemshotRequest) {
        const response = await this.createStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiCreateStreemshotRequest: streemApiCreateStreemshotRequest });
        return await response.value();
    }
    /**
     * Create a streemshot revision, which may include new AR data
     * Create Streemshot Revision
     */
    async createStreemshotRevisionRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling createStreemshotRevision.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling createStreemshotRevision.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/revisions`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiCreateStreemshotRevisionRequestToJSON(requestParameters.streemApiCreateStreemshotRevisionRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiCreateStreemshotRevisionResponseFromJSON(jsonValue));
    }
    /**
     * Create a streemshot revision, which may include new AR data
     * Create Streemshot Revision
     */
    async createStreemshotRevision(roomSid, streemshotSid, streemApiCreateStreemshotRevisionRequest) {
        const response = await this.createStreemshotRevisionRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiCreateStreemshotRevisionRequest: streemApiCreateStreemshotRevisionRequest });
        return await response.value();
    }
    /**
     * Delete a video recording bookmark
     * Delete Bookmark
     */
    async deleteBookmarkRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteBookmark.');
        }
        if (requestParameters.bookmarkSid === null || requestParameters.bookmarkSid === undefined) {
            throw new runtime.RequiredError('bookmarkSid', 'Required parameter requestParameters.bookmarkSid was null or undefined when calling deleteBookmark.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/bookmarks/{bookmark_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"bookmark_sid"}}`, encodeURIComponent(String(requestParameters.bookmarkSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a video recording bookmark
     * Delete Bookmark
     */
    async deleteBookmark(roomSid, bookmarkSid) {
        await this.deleteBookmarkRaw({ roomSid: roomSid, bookmarkSid: bookmarkSid });
    }
    /**
     * Delete the specified GPS position
     * Delete GPS
     */
    async deleteGpsPositionRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteGpsPosition.');
        }
        if (requestParameters.gpsPositionSid === null || requestParameters.gpsPositionSid === undefined) {
            throw new runtime.RequiredError('gpsPositionSid', 'Required parameter requestParameters.gpsPositionSid was null or undefined when calling deleteGpsPosition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/gps-positions/{gps_position_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"gps_position_sid"}}`, encodeURIComponent(String(requestParameters.gpsPositionSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete the specified GPS position
     * Delete GPS
     */
    async deleteGpsPosition(roomSid, gpsPositionSid) {
        await this.deleteGpsPositionRaw({ roomSid: roomSid, gpsPositionSid: gpsPositionSid });
    }
    /**
     * Delete a layout estimation
     * Delete Layout Estimation
     */
    async deleteLayoutEstimationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteLayoutEstimation.');
        }
        if (requestParameters.layoutEstimationSid === null || requestParameters.layoutEstimationSid === undefined) {
            throw new runtime.RequiredError('layoutEstimationSid', 'Required parameter requestParameters.layoutEstimationSid was null or undefined when calling deleteLayoutEstimation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/layout-estimations/{layout_estimation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"layout_estimation_sid"}}`, encodeURIComponent(String(requestParameters.layoutEstimationSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a layout estimation
     * Delete Layout Estimation
     */
    async deleteLayoutEstimation(roomSid, layoutEstimationSid) {
        await this.deleteLayoutEstimationRaw({ roomSid: roomSid, layoutEstimationSid: layoutEstimationSid });
    }
    /**
     * Delete a mesh
     * Delete Mesh
     */
    async deleteMeshRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteMesh.');
        }
        if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
            throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling deleteMesh.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a mesh
     * Delete Mesh
     */
    async deleteMesh(roomSid, meshSid) {
        await this.deleteMeshRaw({ roomSid: roomSid, meshSid: meshSid });
    }
    /**
     * Delete a Recording artifact, which will eventually permanently remove it from storage
     * Delete Recording
     */
    async deleteRecordingRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRecording.');
        }
        if (requestParameters.recordingSid === null || requestParameters.recordingSid === undefined) {
            throw new runtime.RequiredError('recordingSid', 'Required parameter requestParameters.recordingSid was null or undefined when calling deleteRecording.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/recordings/{recording_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"recording_sid"}}`, encodeURIComponent(String(requestParameters.recordingSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a Recording artifact, which will eventually permanently remove it from storage
     * Delete Recording
     */
    async deleteRecording(roomSid, recordingSid) {
        await this.deleteRecordingRaw({ roomSid: roomSid, recordingSid: recordingSid });
    }
    /**
     * Delete the Room, which deletes all Assets from storage, and hides from Call Logs
     * Delete Room
     */
    async deleteRoomRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoom.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete the Room, which deletes all Assets from storage, and hides from Call Logs
     * Delete Room
     */
    async deleteRoom(roomSid) {
        await this.deleteRoomRaw({ roomSid: roomSid });
    }
    /**
     * Delete the Note from the specified Room
     * Delete Room Note
     */
    async deleteRoomNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoomNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete the Note from the specified Room
     * Delete Room Note
     */
    async deleteRoomNote(roomSid) {
        await this.deleteRoomNoteRaw({ roomSid: roomSid });
    }
    /**
     * Delete Room Outcome Report artifact for this Room
     * Delete Room Outcome Report
     */
    async deleteRoomOutcomeReportRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteRoomOutcomeReport.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Room Outcome Report artifact for this Room
     * Delete Room Outcome Report
     */
    async deleteRoomOutcomeReport(roomSid) {
        await this.deleteRoomOutcomeReportRaw({ roomSid: roomSid });
    }
    /**
     * Delete a sceneshot
     * Delete Sceneshot
     */
    async deleteSceneshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteSceneshot.');
        }
        if (requestParameters.sceneshotSid === null || requestParameters.sceneshotSid === undefined) {
            throw new runtime.RequiredError('sceneshotSid', 'Required parameter requestParameters.sceneshotSid was null or undefined when calling deleteSceneshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/sceneshots/{sceneshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"sceneshot_sid"}}`, encodeURIComponent(String(requestParameters.sceneshotSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a sceneshot
     * Delete Sceneshot
     */
    async deleteSceneshot(roomSid, sceneshotSid) {
        await this.deleteSceneshotRaw({ roomSid: roomSid, sceneshotSid: sceneshotSid });
    }
    /**
     * Delete a Streemshot, which will eventually permanently remove it from storage
     * Delete Streemshot
     */
    async deleteStreemshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteStreemshot.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling deleteStreemshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a Streemshot, which will eventually permanently remove it from storage
     * Delete Streemshot
     */
    async deleteStreemshot(roomSid, streemshotSid) {
        await this.deleteStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
    }
    /**
     * Delete the text Note from a Streemshot
     * Delete Streemshot Note
     */
    async deleteStreemshotNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteStreemshotNote.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling deleteStreemshotNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete the text Note from a Streemshot
     * Delete Streemshot Note
     */
    async deleteStreemshotNote(roomSid, streemshotSid) {
        await this.deleteStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
    }
    /**
     * Delete a textured mesh
     * Delete Textured Mesh
     */
    async deleteTexturedMeshRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling deleteTexturedMesh.');
        }
        if (requestParameters.texturedMeshSid === null || requestParameters.texturedMeshSid === undefined) {
            throw new runtime.RequiredError('texturedMeshSid', 'Required parameter requestParameters.texturedMeshSid was null or undefined when calling deleteTexturedMesh.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/textured-meshes/{textured_mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"textured_mesh_sid"}}`, encodeURIComponent(String(requestParameters.texturedMeshSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Delete a textured mesh
     * Delete Textured Mesh
     */
    async deleteTexturedMesh(roomSid, texturedMeshSid) {
        const response = await this.deleteTexturedMeshRaw({ roomSid: roomSid, texturedMeshSid: texturedMeshSid });
        return await response.value();
    }
    /**
     * Finalize the note for the specified Room
     * Finalize Room Note
     */
    async finalizeRoomNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling finalizeRoomNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/note/~finalize`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiFinalizeRoomNoteResponseFromJSON(jsonValue));
    }
    /**
     * Finalize the note for the specified Room
     * Finalize Room Note
     */
    async finalizeRoomNote(roomSid, body) {
        const response = await this.finalizeRoomNoteRaw({ roomSid: roomSid, body: body });
        return await response.value();
    }
    /**
     * Fulfill a mesh request
     * Fulfill Mesh Request
     */
    async fulfillMeshRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillMesh.');
        }
        if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
            throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling fulfillMesh.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiFulfillMeshResponseFromJSON(jsonValue));
    }
    /**
     * Fulfill a mesh request
     * Fulfill Mesh Request
     */
    async fulfillMesh(roomSid, meshSid) {
        const response = await this.fulfillMeshRaw({ roomSid: roomSid, meshSid: meshSid });
        return await response.value();
    }
    /**
     * Fulfill a Recording artifact after upload is complete
     * Fulfill Recording
     */
    async fulfillRecordingRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillRecording.');
        }
        if (requestParameters.recordingSid === null || requestParameters.recordingSid === undefined) {
            throw new runtime.RequiredError('recordingSid', 'Required parameter requestParameters.recordingSid was null or undefined when calling fulfillRecording.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/recordings/{recording_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"recording_sid"}}`, encodeURIComponent(String(requestParameters.recordingSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiFulfillRecordingRequestToJSON(requestParameters.streemApiFulfillRecordingRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiFulfillRecordingResponseFromJSON(jsonValue));
    }
    /**
     * Fulfill a Recording artifact after upload is complete
     * Fulfill Recording
     */
    async fulfillRecording(roomSid, recordingSid, streemApiFulfillRecordingRequest) {
        const response = await this.fulfillRecordingRaw({ roomSid: roomSid, recordingSid: recordingSid, streemApiFulfillRecordingRequest: streemApiFulfillRecordingRequest });
        return await response.value();
    }
    /**
     * Fulfill a streemshot request
     * Fulfill Streemshot Request
     */
    async fulfillStreemshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling fulfillStreemshot.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling fulfillStreemshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/fulfill`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiFulfillStreemshotRequestToJSON(requestParameters.streemApiFulfillStreemshotRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiFulfillStreemshotResponseFromJSON(jsonValue));
    }
    /**
     * Fulfill a streemshot request
     * Fulfill Streemshot Request
     */
    async fulfillStreemshot(roomSid, streemshotSid, streemApiFulfillStreemshotRequest) {
        const response = await this.fulfillStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiFulfillStreemshotRequest: streemApiFulfillStreemshotRequest });
        return await response.value();
    }
    /**
     * Get info about the specified video recording bookmark
     * Get Bookmark
     */
    async getBookmarkRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getBookmark.');
        }
        if (requestParameters.bookmarkSid === null || requestParameters.bookmarkSid === undefined) {
            throw new runtime.RequiredError('bookmarkSid', 'Required parameter requestParameters.bookmarkSid was null or undefined when calling getBookmark.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/bookmarks/{bookmark_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"bookmark_sid"}}`, encodeURIComponent(String(requestParameters.bookmarkSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetBookmarkResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified video recording bookmark
     * Get Bookmark
     */
    async getBookmark(roomSid, bookmarkSid) {
        const response = await this.getBookmarkRaw({ roomSid: roomSid, bookmarkSid: bookmarkSid });
        return await response.value();
    }
    /**
     * Get info about the specified GPS position
     * Get GPS
     */
    async getGpsPositionRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getGpsPosition.');
        }
        if (requestParameters.gpsPositionSid === null || requestParameters.gpsPositionSid === undefined) {
            throw new runtime.RequiredError('gpsPositionSid', 'Required parameter requestParameters.gpsPositionSid was null or undefined when calling getGpsPosition.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/gps-positions/{gps_position_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"gps_position_sid"}}`, encodeURIComponent(String(requestParameters.gpsPositionSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetGpsPositionResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified GPS position
     * Get GPS
     */
    async getGpsPosition(roomSid, gpsPositionSid) {
        const response = await this.getGpsPositionRaw({ roomSid: roomSid, gpsPositionSid: gpsPositionSid });
        return await response.value();
    }
    /**
     * Get info about the specified layout estimation
     * Get Layout Estimation
     */
    async getLayoutEstimationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getLayoutEstimation.');
        }
        if (requestParameters.layoutEstimationSid === null || requestParameters.layoutEstimationSid === undefined) {
            throw new runtime.RequiredError('layoutEstimationSid', 'Required parameter requestParameters.layoutEstimationSid was null or undefined when calling getLayoutEstimation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/layout-estimations/{layout_estimation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"layout_estimation_sid"}}`, encodeURIComponent(String(requestParameters.layoutEstimationSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetLayoutEstimationResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified layout estimation
     * Get Layout Estimation
     */
    async getLayoutEstimation(roomSid, layoutEstimationSid) {
        const response = await this.getLayoutEstimationRaw({ roomSid: roomSid, layoutEstimationSid: layoutEstimationSid });
        return await response.value();
    }
    /**
     * Get info about the specified mesh
     * Get Mesh
     */
    async getMeshRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getMesh.');
        }
        if (requestParameters.meshSid === null || requestParameters.meshSid === undefined) {
            throw new runtime.RequiredError('meshSid', 'Required parameter requestParameters.meshSid was null or undefined when calling getMesh.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/meshes/{mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"mesh_sid"}}`, encodeURIComponent(String(requestParameters.meshSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetMeshResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified mesh
     * Get Mesh
     */
    async getMesh(roomSid, meshSid) {
        const response = await this.getMeshRaw({ roomSid: roomSid, meshSid: meshSid });
        return await response.value();
    }
    /**
     * Get information about the specified Room
     * Get Room
     */
    async getRoomRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoom.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomResponseFromJSON(jsonValue));
    }
    /**
     * Get information about the specified Room
     * Get Room
     */
    async getRoom(roomSid) {
        const response = await this.getRoomRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Get the Call Log Entry for this Room and User
     * Get Call Log Entry
     */
    async getRoomCallLogEntryRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomCallLogEntry.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/call-log-entry`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomCallLogEntryResponseFromJSON(jsonValue));
    }
    /**
     * Get the Call Log Entry for this Room and User
     * Get Call Log Entry
     */
    async getRoomCallLogEntry(roomSid) {
        const response = await this.getRoomCallLogEntryRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Get information for the specified invitation within this Room
     * Get Room Invitation
     */
    async getRoomInvitationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomInvitation.');
        }
        if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
            throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling getRoomInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Get information for the specified invitation within this Room
     * Get Room Invitation
     */
    async getRoomInvitation(roomSid, invitationSid) {
        const response = await this.getRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid });
        return await response.value();
    }
    /**
     * Gets the text Note for the specified Room
     * Get Room Note
     */
    async getRoomNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomNoteResponseFromJSON(jsonValue));
    }
    /**
     * Gets the text Note for the specified Room
     * Get Room Note
     */
    async getRoomNote(roomSid) {
        const response = await this.getRoomNoteRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Get Room Outcome Report artifact for this Room
     * Get Room Outcome Report
     */
    async getRoomOutcomeReportRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomOutcomeReport.');
        }
        if (requestParameters.roomOutcomeReportSid === null || requestParameters.roomOutcomeReportSid === undefined) {
            throw new runtime.RequiredError('roomOutcomeReportSid', 'Required parameter requestParameters.roomOutcomeReportSid was null or undefined when calling getRoomOutcomeReport.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/outcome-reports/{room_outcome_report_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"room_outcome_report_sid"}}`, encodeURIComponent(String(requestParameters.roomOutcomeReportSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomOutcomeReportResponseFromJSON(jsonValue));
    }
    /**
     * Get Room Outcome Report artifact for this Room
     * Get Room Outcome Report
     */
    async getRoomOutcomeReport(roomSid, roomOutcomeReportSid) {
        const response = await this.getRoomOutcomeReportRaw({ roomSid: roomSid, roomOutcomeReportSid: roomOutcomeReportSid });
        return await response.value();
    }
    /**
     * Get a Share Token by `token_sid`
     * Get Share Token
     */
    async getRoomShareTokenRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomShareToken.');
        }
        if (requestParameters.tokenSid === null || requestParameters.tokenSid === undefined) {
            throw new runtime.RequiredError('tokenSid', 'Required parameter requestParameters.tokenSid was null or undefined when calling getRoomShareToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/share-tokens/{token_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"token_sid"}}`, encodeURIComponent(String(requestParameters.tokenSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomShareTokenResponseFromJSON(jsonValue));
    }
    /**
     * Get a Share Token by `token_sid`
     * Get Share Token
     */
    async getRoomShareToken(roomSid, tokenSid) {
        const response = await this.getRoomShareTokenRaw({ roomSid: roomSid, tokenSid: tokenSid });
        return await response.value();
    }
    /**
     * Gets all room wall items and decrypts if necessary. This is an admin endpoint for manual testing. Do not use in code.
     * Get Wall Items
     */
    async getRoomWallItemsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getRoomWallItems.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/wall-items`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetRoomWallItemsResponseFromJSON(jsonValue));
    }
    /**
     * Gets all room wall items and decrypts if necessary. This is an admin endpoint for manual testing. Do not use in code.
     * Get Wall Items
     */
    async getRoomWallItems(roomSid) {
        const response = await this.getRoomWallItemsRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Get info about the specified sceneshot
     * Get Sceneshot
     */
    async getSceneshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getSceneshot.');
        }
        if (requestParameters.sceneshotSid === null || requestParameters.sceneshotSid === undefined) {
            throw new runtime.RequiredError('sceneshotSid', 'Required parameter requestParameters.sceneshotSid was null or undefined when calling getSceneshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/sceneshots/{sceneshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"sceneshot_sid"}}`, encodeURIComponent(String(requestParameters.sceneshotSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetSceneshotResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified sceneshot
     * Get Sceneshot
     */
    async getSceneshot(roomSid, sceneshotSid) {
        const response = await this.getSceneshotRaw({ roomSid: roomSid, sceneshotSid: sceneshotSid });
        return await response.value();
    }
    /**
     * Get info about the specified Streemshot
     * Get Streemshot
     */
    async getStreemshotRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getStreemshot.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling getStreemshot.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetStreemshotResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified Streemshot
     * Get Streemshot
     */
    async getStreemshot(roomSid, streemshotSid) {
        const response = await this.getStreemshotRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
        return await response.value();
    }
    /**
     * Get the text Note on an existing Streemshot
     * Get Streemshot Note
     */
    async getStreemshotNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getStreemshotNote.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling getStreemshotNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetStreemshotNoteResponseFromJSON(jsonValue));
    }
    /**
     * Get the text Note on an existing Streemshot
     * Get Streemshot Note
     */
    async getStreemshotNote(roomSid, streemshotSid) {
        const response = await this.getStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid });
        return await response.value();
    }
    /**
     * Get info about the specified textured mesh
     * Get Textured Mesh
     */
    async getTexturedMeshRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling getTexturedMesh.');
        }
        if (requestParameters.texturedMeshSid === null || requestParameters.texturedMeshSid === undefined) {
            throw new runtime.RequiredError('texturedMeshSid', 'Required parameter requestParameters.texturedMeshSid was null or undefined when calling getTexturedMesh.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/textured-meshes/{textured_mesh_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"textured_mesh_sid"}}`, encodeURIComponent(String(requestParameters.texturedMeshSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiGetTexturedMeshResponseFromJSON(jsonValue));
    }
    /**
     * Get info about the specified textured mesh
     * Get Textured Mesh
     */
    async getTexturedMesh(roomSid, texturedMeshSid) {
        const response = await this.getTexturedMeshRaw({ roomSid: roomSid, texturedMeshSid: texturedMeshSid });
        return await response.value();
    }
    /**
     * Leaves the Room, which may close the Room if this is the last Participant
     * Leave Room
     */
    async leaveRoomRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling leaveRoom.');
        }
        if (requestParameters.userSid === null || requestParameters.userSid === undefined) {
            throw new runtime.RequiredError('userSid', 'Required parameter requestParameters.userSid was null or undefined when calling leaveRoom.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/participants/{user_sid}/leave`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"user_sid"}}`, encodeURIComponent(String(requestParameters.userSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiLeaveRoomResponseFromJSON(jsonValue));
    }
    /**
     * Leaves the Room, which may close the Room if this is the last Participant
     * Leave Room
     */
    async leaveRoom(roomSid, userSid) {
        const response = await this.leaveRoomRaw({ roomSid: roomSid, userSid: userSid });
        return await response.value();
    }
    /**
     * List all GPS positions for the Room
     * List GPS
     */
    async listGpsPositionsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listGpsPositions.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/gps-positions`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListGpsPositionsResponseFromJSON(jsonValue));
    }
    /**
     * List all GPS positions for the Room
     * List GPS
     */
    async listGpsPositions(roomSid, pageSize, pageToken) {
        const response = await this.listGpsPositionsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all Meshes for this Room
     * List Meshes
     */
    async listMeshesRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listMeshes.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/meshes`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListMeshesResponseFromJSON(jsonValue));
    }
    /**
     * List all Meshes for this Room
     * List Meshes
     */
    async listMeshes(roomSid, pageSize, pageToken) {
        const response = await this.listMeshesRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all Recording artifacts for this Room
     * List Recordings
     */
    async listRecordingsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRecordings.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/recordings`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRecordingsResponseFromJSON(jsonValue));
    }
    /**
     * List all Recording artifacts for this Room
     * List Recordings
     */
    async listRecordings(roomSid, pageSize, pageToken) {
        const response = await this.listRecordingsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all Artifacts for this Room, such as Recordings, Streemshots, etc.
     * List Artifacts
     */
    async listRoomArtifactsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomArtifacts.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/artifacts`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomArtifactsResponseFromJSON(jsonValue));
    }
    /**
     * List all Artifacts for this Room, such as Recordings, Streemshots, etc.
     * List Artifacts
     */
    async listRoomArtifacts(roomSid, pageSize, pageToken) {
        const response = await this.listRoomArtifactsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all RoomOutcomeReports for this Room
     * List RoomOutcomeReports
     */
    async listRoomOutcomeReportsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomOutcomeReports.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/outcome-reports`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomOutcomeReportsResponseFromJSON(jsonValue));
    }
    /**
     * List all RoomOutcomeReports for this Room
     * List RoomOutcomeReports
     */
    async listRoomOutcomeReports(roomSid, pageSize, pageToken) {
        const response = await this.listRoomOutcomeReportsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * Get the list of Participants for a Room
     * List Participants
     */
    async listRoomParticipantsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomParticipants.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/participants`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomParticipantsResponseFromJSON(jsonValue));
    }
    /**
     * Get the list of Participants for a Room
     * List Participants
     */
    async listRoomParticipants(roomSid) {
        const response = await this.listRoomParticipantsRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * List Share Tokens for this Room, which give readonly access to the Assets of the Room
     * List Share Tokens
     */
    async listRoomShareTokensRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listRoomShareTokens.');
        }
        const queryParameters = {};
        if (requestParameters.includeExpired !== undefined) {
            queryParameters['include_expired'] = requestParameters.includeExpired;
        }
        if (requestParameters.expires !== undefined) {
            queryParameters['expires'] = requestParameters.expires;
        }
        if (requestParameters.view !== undefined) {
            queryParameters['view'] = requestParameters.view;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/share-tokens`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomShareTokensResponseFromJSON(jsonValue));
    }
    /**
     * List Share Tokens for this Room, which give readonly access to the Assets of the Room
     * List Share Tokens
     */
    async listRoomShareTokens(roomSid, includeExpired, expires, view, pageSize, pageToken) {
        const response = await this.listRoomShareTokensRaw({ roomSid: roomSid, includeExpired: includeExpired, expires: expires, view: view, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List Rooms by various filters.  You must provide the `company_sid` param at a minimum.
     * List Rooms
     */
    async listRoomsRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.createdByUserSid !== undefined) {
            queryParameters['created_by_user_sid'] = requestParameters.createdByUserSid;
        }
        if (requestParameters.companySid !== undefined) {
            queryParameters['company_sid'] = requestParameters.companySid;
        }
        if (requestParameters.referenceId !== undefined) {
            queryParameters['reference_id'] = requestParameters.referenceId;
        }
        if (requestParameters.integrationId !== undefined) {
            queryParameters['integration_id'] = requestParameters.integrationId;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomsResponseFromJSON(jsonValue));
    }
    /**
     * List Rooms by various filters.  You must provide the `company_sid` param at a minimum.
     * List Rooms
     */
    async listRooms(createdByUserSid, companySid, referenceId, integrationId, pageSize, pageToken) {
        const response = await this.listRoomsRaw({ createdByUserSid: createdByUserSid, companySid: companySid, referenceId: referenceId, integrationId: integrationId, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all Sceneshots for this Room
     * List Sceneshots
     */
    async listSceneshotsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listSceneshots.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/sceneshots`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListSceneshotsResponseFromJSON(jsonValue));
    }
    /**
     * List all Sceneshots for this Room
     * List Sceneshots
     */
    async listSceneshots(roomSid, pageSize, pageToken) {
        const response = await this.listSceneshotsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List all Streemshot Artifacts for this Room
     * List Streemshots
     */
    async listStreemshotsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listStreemshots.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListStreemshotsResponseFromJSON(jsonValue));
    }
    /**
     * List all Streemshot Artifacts for this Room
     * List Streemshots
     */
    async listStreemshots(roomSid, pageSize, pageToken) {
        const response = await this.listStreemshotsRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * List Transcription for this room
     * List Transcription
     */
    async listTranscriptionRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling listTranscription.');
        }
        const queryParameters = {};
        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }
        if (requestParameters.pageToken !== undefined) {
            queryParameters['page_token'] = requestParameters.pageToken;
        }
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/transcription`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiListRoomTranscriptionResponseFromJSON(jsonValue));
    }
    /**
     * List Transcription for this room
     * List Transcription
     */
    async listTranscription(roomSid, pageSize, pageToken) {
        const response = await this.listTranscriptionRaw({ roomSid: roomSid, pageSize: pageSize, pageToken: pageToken });
        return await response.value();
    }
    /**
     * Pause an ongiong twilio recording, which will stop recording until resume request is received
     * Pause Recording
     */
    async pauseRoomRecordingRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling pauseRoomRecording.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/~pause-recording`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Pause an ongiong twilio recording, which will stop recording until resume request is received
     * Pause Recording
     */
    async pauseRoomRecording(roomSid) {
        const response = await this.pauseRoomRecordingRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Mark invitation as rejected (by invitee)
     * Reject Invitation
     */
    async rejectRoomInvitationRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling rejectRoomInvitation.');
        }
        if (requestParameters.invitationSid === null || requestParameters.invitationSid === undefined) {
            throw new runtime.RequiredError('invitationSid', 'Required parameter requestParameters.invitationSid was null or undefined when calling rejectRoomInvitation.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/invitations/{invitation_sid}/reject`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"invitation_sid"}}`, encodeURIComponent(String(requestParameters.invitationSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiRejectRoomInvitationRequestToJSON(requestParameters.streemApiRejectRoomInvitationRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiRejectRoomInvitationResponseFromJSON(jsonValue));
    }
    /**
     * Mark invitation as rejected (by invitee)
     * Reject Invitation
     */
    async rejectRoomInvitation(roomSid, invitationSid, streemApiRejectRoomInvitationRequest) {
        const response = await this.rejectRoomInvitationRaw({ roomSid: roomSid, invitationSid: invitationSid, streemApiRejectRoomInvitationRequest: streemApiRejectRoomInvitationRequest });
        return await response.value();
    }
    /**
     */
    async repopulateTranscriptionSegmentsRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling repopulateTranscriptionSegments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/transcription/~repopulate-segments`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async repopulateTranscriptionSegments(roomSid) {
        await this.repopulateTranscriptionSegmentsRaw({ roomSid: roomSid });
    }
    /**
     * Resume a recording, which will continue recording until pause request is received
     * Resume Recording
     */
    async resumeRoomRecordingRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling resumeRoomRecording.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/~resume-recording`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Resume a recording, which will continue recording until pause request is received
     * Resume Recording
     */
    async resumeRoomRecording(roomSid) {
        const response = await this.resumeRoomRecordingRaw({ roomSid: roomSid });
        return await response.value();
    }
    /**
     * Revoke a Share Token, which sets its `expires_at` value to now
     * Revoke Share Token
     */
    async revokeRoomShareTokenRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling revokeRoomShareToken.');
        }
        if (requestParameters.tokenSid === null || requestParameters.tokenSid === undefined) {
            throw new runtime.RequiredError('tokenSid', 'Required parameter requestParameters.tokenSid was null or undefined when calling revokeRoomShareToken.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/share-tokens/{token_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"token_sid"}}`, encodeURIComponent(String(requestParameters.tokenSid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Revoke a Share Token, which sets its `expires_at` value to now
     * Revoke Share Token
     */
    async revokeRoomShareToken(roomSid, tokenSid) {
        await this.revokeRoomShareTokenRaw({ roomSid: roomSid, tokenSid: tokenSid });
    }
    /**
     * Update the room
     * Update room
     */
    async updateRoomRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateRoom.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateRoomRequestToJSON(requestParameters.streemApiUpdateRoomRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateRoomResponseFromJSON(jsonValue));
    }
    /**
     * Update the room
     * Update room
     */
    async updateRoom(roomSid, streemApiUpdateRoomRequest) {
        const response = await this.updateRoomRaw({ roomSid: roomSid, streemApiUpdateRoomRequest: streemApiUpdateRoomRequest });
        return await response.value();
    }
    /**
     * Updates the text Note for the specified Room
     * Update Room Note
     */
    async updateRoomNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateRoomNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateRoomNoteRequestToJSON(requestParameters.streemApiUpdateRoomNoteRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateRoomNoteResponseFromJSON(jsonValue));
    }
    /**
     * Updates the text Note for the specified Room
     * Update Room Note
     */
    async updateRoomNote(roomSid, streemApiUpdateRoomNoteRequest) {
        const response = await this.updateRoomNoteRaw({ roomSid: roomSid, streemApiUpdateRoomNoteRequest: streemApiUpdateRoomNoteRequest });
        return await response.value();
    }
    /**
     * Update the text Note on an existing Streemshot
     * Update Streemshot Note
     */
    async updateStreemshotNoteRaw(requestParameters) {
        if (requestParameters.roomSid === null || requestParameters.roomSid === undefined) {
            throw new runtime.RequiredError('roomSid', 'Required parameter requestParameters.roomSid was null or undefined when calling updateStreemshotNote.');
        }
        if (requestParameters.streemshotSid === null || requestParameters.streemshotSid === undefined) {
            throw new runtime.RequiredError('streemshotSid', 'Required parameter requestParameters.streemshotSid was null or undefined when calling updateStreemshotNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/rooms/{room_sid}/streemshots/{streemshot_sid}/note`.replace(`{${"room_sid"}}`, encodeURIComponent(String(requestParameters.roomSid))).replace(`{${"streemshot_sid"}}`, encodeURIComponent(String(requestParameters.streemshotSid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StreemApiUpdateStreemshotNoteRequestToJSON(requestParameters.streemApiUpdateStreemshotNoteRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => StreemApiUpdateStreemshotNoteResponseFromJSON(jsonValue));
    }
    /**
     * Update the text Note on an existing Streemshot
     * Update Streemshot Note
     */
    async updateStreemshotNote(roomSid, streemshotSid, streemApiUpdateStreemshotNoteRequest) {
        const response = await this.updateStreemshotNoteRaw({ roomSid: roomSid, streemshotSid: streemshotSid, streemApiUpdateStreemshotNoteRequest: streemApiUpdateStreemshotNoteRequest });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ListRoomShareTokensExpires;
(function (ListRoomShareTokensExpires) {
    ListRoomShareTokensExpires["ANY"] = "EXPIRES_ANY";
    ListRoomShareTokensExpires["NO"] = "EXPIRES_NO";
    ListRoomShareTokensExpires["YES"] = "EXPIRES_YES";
})(ListRoomShareTokensExpires || (ListRoomShareTokensExpires = {}));
/**
    * @export
    * @enum {string}
    */
export var ListRoomShareTokensView;
(function (ListRoomShareTokensView) {
    ListRoomShareTokensView["BASIC"] = "VIEW_BASIC";
    ListRoomShareTokensView["FULL"] = "VIEW_FULL";
    ListRoomShareTokensView["INVALID"] = "VIEW_INVALID";
})(ListRoomShareTokensView || (ListRoomShareTokensView = {}));
//# sourceMappingURL=RoomsApi.js.map